import React, { Fragment } from "react";
import { print } from "graphql";
import { Mutation } from "@apollo/client/react/components";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import SimpleModal from "../../SimpleModal";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import UISchemaResolver from "../../../data/schema/form_ui/_resolver";
import PrefillUtil from "../../../global/utils/prefillHelper";
import GQLUtil from "../../../global/utils/gqlHelper";
import util from "../../Utils/mappers";
import FormExit from "../../SimpleForm/UI/FormExit";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { connect } from "react-redux";
import {
  GET_790_FORM_DATA,
  UPDATE_790_FORM,
  SUBMIT_790_FORM,
  GET_790A_PROFILES,
} from "./queries";
import renderDeleteButton from "../renderDeleteButton";
import renderSaveButton from "../renderSaveButton";
import renderFormActions from "../renderFormActions";
import { cleanData, validateOnLoad } from "./helpers";
import isTester from "../../SimpleForm/SubmissionUtilities/isTester";
import FullScreenSpinner from "../../../global/components/FullScreenSpinner";
import { fetchAllReferenceData } from "../../../global/app/actions/actions_reference";

class Form790 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closeModal: false,
      modalOpen: true,
      formSubmitting: false,
      profiles: [],
      counties: undefined,
      formData:
        (this.props.history.location.state &&
          this.props.history.location.state.initialValues) ||
        {},
      form_ui: undefined,
      reuse:
        (this.props.history.location.state &&
          this.props.history.location.state.reuse) ||
        false,
    };
  }

  componentDidMount = async () => {
    const application_type = "790A";
    const application_id = this.props.match.params.id;

    // if user is currently in app and reference data updates we want to fetch latest data when they open up the form
    // before we were checking if data existed in redux and if so skipping the fetch and not getting the latest data
    this.props.dispatch(fetchAllReferenceData());

    let profiles = await GQLUtil.genericGQLQuery(print(GET_790A_PROFILES));
    // Convert profiles to V3
    profiles.data.getUserProfileInfo.MaterialTermsProfiles =
      profiles?.data?.getUserProfileInfo?.MaterialTermsProfiles?.map(
        (profile) => {
          const convertToV3 = {
            "Meal Provision": "Provision of Meals",
            "Job Requirements": "Job Qualifications/Requirements",
            "Pay Deductions": "Deductions from Pay",
            "Referral and Hiring Instructions":
              "Other Material Terms and Conditions",
          };

          // Rename values from V2 to V3 values
          if (!!convertToV3[profile?.material_terms_section_number]) {
            profile.material_terms_section_number =
              convertToV3[profile?.material_terms_section_number];
          }

          // In V3, summary will match section number except when "Other Material Terms and Conditions"
          if (
            profile.material_terms_section_number !==
            "Other Material Terms and Conditions"
          ) {
            profile.material_terms_summary =
              profile?.material_terms_section_number;
          }

          return profile;
        }
      );

    const profiles_parsed = PrefillUtil.getPrefillProfileOptions(
      profiles.data.getUserProfileInfo,
      application_type,
      "all"
    );

    util
      .getCounties()
      .then((data) => this.setState({ counties: data }))
      .catch((e) => {
        console.log(`unable to fetch counties`);
      });

    const form = await GQLUtil.genericGQLQuery(print(GET_790_FORM_DATA), {
      id: application_id,
    });
    let formData = form.data?.getForm790AById?.payload;
    let formVersionId = form.data.getForm790AById.formVersionId;
    if (form.data !== null) {
      let form_ui = form.data.getForm790AById.form_ui;
      this.setState({
        profiles: profiles_parsed,
        form_ui,
      });
      if (formData) {
        if (!formData?.formVersionId) formData["formVersionId"] = formVersionId;
        this.setState({
          formData,
        });
      } else {
        // On initial form creation, form data is null but we still want to set the form version to 2
        // This is in case there is any visibility depedent content.
        this.setState({
          formData: { formVersionId },
        });
      }
    }

    /**
     * ! 790A Reuse
     * ! This is an important step in reuse where the values come back here to be injected into formData class state.
     * ! The values are then sent downstream into SimpleForm.
     *
     * On initial reuse we import from history object but subsequent updates we do not.
     * If payload data from cosmos comes back we use that instead.
     */
    if (
      this.props.history.location.state &&
      this.props.history.location.state.initialValues
    ) {
      this.setState({
        formData: {
          ...this.props.history.location.state.initialValues,
          ...(formData ?? {}),
          formVersionId,
        },
      });
    }
  };

  render790 = () => {
    const application_type = "790A";
    const resolverName = "SubmitForm790A";
    const application_id = this.props.match.params.id;
    const useRecaptcha = this.props.user?.Recaptcha !== false;
    const { executeRecaptcha } = useRecaptcha
      ? this.props.googleReCaptchaProps
      : {};

    const handleToggle = () => {
      this.setState({ closeModal: !this.state.closeModal });
    };
    const renderFormExit = (values, form_ui, form_ui_name) => {
      return (
        <FormExit
          renderDeleteButton={() =>
            renderDeleteButton(
              application_id,
              application_type,
              this.props.history,
              undefined,
              this.props.user.GroupRole
            )
          }
          renderSaveButton={() =>
            renderSaveButton(
              UPDATE_790_FORM,
              values,
              "Form790AFormData",
              application_id,
              cleanData,
              this.props.history,
              "Save as Initiated",
              undefined,
              undefined,
              form_ui,
              form_ui_name
            )
          }
          closeModal={this.state.closeModal}
          toggleModal={handleToggle}
          values={values}
        />
      );
    };

    const setFormSubmittingState = (booleanValue) => {
      this.setState({ formSubmitting: booleanValue });
    };

    const formSubmissionError = (e, application_id) => {
      setFormSubmittingState(false);
      let type;
      let error = JSON.stringify(e);
      if (
        e &&
        e.graphQLErrors &&
        e.graphQLErrors[0] &&
        e.graphQLErrors[0].extensions
      ) {
        error = e.graphQLErrors[0].extensions;
      }
      if (
        e &&
        e.graphQLErrors &&
        e.graphQLErrors[0] &&
        e.graphQLErrors[0].message
      ) {
        type = e.graphQLErrors[0].message;
      }
      this.props.history.push({
        pathname: "/dashboard/error",
        state: {
          application_id,
          formType: application_type,
          error,
          type,
        },
      });
    };

    const formSubmissionSuccess = (res) => {
      const queueError = res?.[`${resolverName}`] === "queue_error";
      setFormSubmittingState(false);
      this.props.history.push({
        pathname: "/dashboard/success",
        state: { formType: application_type, queueError },
      });
    };

    return (
      <Fragment>
        {!this.state.modalOpen ? (
          <Redirect to="/dashboard/application" />
        ) : (
          <SimpleModal
            fullscreen={true}
            toggleModal={handleToggle}
            modalStatus={this.state.modalOpen}
          >
            <Mutation
              mutation={SUBMIT_790_FORM}
              onError={(e) => formSubmissionError(e, application_id)}
              onCompleted={(e) => formSubmissionSuccess(e)}
            >
              {(SubmitForm790A) => (
                <SimpleForm
                  handleSubmit={
                    useRecaptcha
                      ? async (values) => {
                          if (!executeRecaptcha) {
                            return;
                          }
                          const token = await executeRecaptcha(resolverName);
                          setFormSubmittingState(true);
                          SubmitForm790A({
                            variables: {
                              Form790AFormData: cleanData(values),
                              id: application_id,
                              token,
                            },
                          });
                        }
                      : (values) => {
                          setFormSubmittingState(true);
                          SubmitForm790A({
                            variables: {
                              Form790AFormData: cleanData(values),
                              id: application_id,
                            },
                          });
                        }
                  }
                  toggleClose={handleToggle}
                  toggleModal={handleToggle}
                  formExit={this.state.closeModal}
                  renderFormExit={renderFormExit}
                  renderFormActions={renderFormActions(
                    UPDATE_790_FORM,
                    "Form790AFormData",
                    application_id,
                    cleanData,
                    this.props.history,
                    this.state.formSubmitting
                  )} // override default FormActions
                  formSaveMutation={UPDATE_790_FORM}
                  formSaveMutationCallback={({
                    formValues,
                    formUIData,
                    saveForm,
                    profilePrefillMetadata,
                  }) => {
                    saveForm({
                      variables: {
                        formUI790A: formUIData,
                        Form790AFormData: cleanData(formValues),
                        id: application_id,
                        profilePrefillMetadata: profilePrefillMetadata.profiles,
                      },
                    });
                  }}
                  multiPage={true}
                  uiSchema={UISchemaResolver(application_type)}
                  uiSchema_meta={UISchemaResolver(`${application_type}-meta`)}
                  uiSchema_nav={UISchemaResolver(`${application_type}-nav`)}
                  uiSchema_lookup={UISchemaResolver(
                    `${application_type}-lookup`
                  )}
                  inputResolver={inputResolver}
                  initialValues={this.state.formData}
                  profiles={this.state.profiles}
                  counties={this.state.counties}
                  form_ui={this.state.form_ui}
                  form_ui_name={"formUI790A"}
                  formSubmitting={this.state.formSubmitting}
                  returningToForm={this.state.reuse}
                  validateOnLoad={validateOnLoad}
                  disableValidation={
                    (this.props.user &&
                      this.props.user.Roles &&
                      isTester(this.props.user && this.props.user.Roles)) ||
                    false
                  }
                />
              )}
            </Mutation>
          </SimpleModal>
        )}
      </Fragment>
    );
  };

  render() {
    if (this.state.formData !== undefined && this.state.form_ui !== undefined) {
      return <div>{this.render790()}</div>;
    }
    return <FullScreenSpinner />;
  }
}

const mapStateToProps = (state) => ({
  user: state.appReducer.userDataReducer.data,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const ConnectedForm = connect(mapStateToProps, mapDispatchToProps)(Form790);
const RoutedForm = withRouter(ConnectedForm);

const FormWrapper = (props) => {
  const useRecaptcha = props.user?.Recaptcha !== false;
  const ComponentToRender = useRecaptcha
    ? withGoogleReCaptcha(RoutedForm)
    : RoutedForm;

  return <ComponentToRender {...props} />;
};

export default FormWrapper;
